export const MenuRouter = [{
  // has: 'workinghours-list1',
  path: 'service/list',
  icon: ' iconfont iconservice',
  name: 'service',
  title: '服务项目',
  component: () => import('@/views/gip/service/service.vue')
}]



// WEBPACK FOOTER //
// ./src/router/service/service.js